import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgOffScreen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M33 6v9h9M15 6v9H6M15 42v-9H6M33 42v-9h8.9"
      stroke="#333"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgOffScreen)
const Memo = memo(ForwardRef)
export default Memo
